import React, { Component } from "react";
import Header from "../../components/header/Header";

import TopButton from "../../components/topButton/TopButton";
// import SocialMedia from "../../components/socialMedia/SocialMedia";
// import Button from "../../components/button/Button";
// import BlogsImg from "./BlogsImg";
// import AddressImg from "./AddressImg";
// import { Fade } from "react-reveal";
import "./ContactComponent.css";
// import { greeting, contactPageData } from "../../portfolio.js";

// import Footer from "./Footer";
import Contact1 from "./Contact";

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <>
        <div className="contact-main">
          <Header theme={theme} />

          <TopButton theme={this.props.theme} />
        </div>
        <Contact1 />
      </>
    );
  }
}

export default Contact;
